import useDisplayMessage from "@utils/useDisplayMessage"
import useNetworkStatus from "@utils/useNetworkStatus"
import { useLayoutEffect, useRef } from "react"
import { NetworkMessage } from "./NetworkMessage"
import useStore from "@state/store"
import { useSocketIO, Room } from "@providers/sockets/SocketIOProvider"

const NetworkStatusIndicator = () => {
  const { show, close, message } = useDisplayMessage()
  const isOnline = useNetworkStatus()
  const firstUpdate = useRef(true)
  const { socket } = useSocketIO()
  const setLocalState = useStore((s) => s.setLocalState)
  const roomTakenOver = useStore((s) => s.roomTakenOver)

  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false
      return
    }

    const handleConnectionChange = () => {
      if (socket?.connected && isOnline) {
        show("You are back ONLINE")
      } else {
        show("You are currently OFFLINE")
        // Show warning if we were controlling a room
        if (roomTakenOver) {
          setLocalState({
            roomTakenOver: null,
            showTakeoverExitWarning: true,
            attemptedRoom: roomTakenOver as Room,
          })
        }
      }
    }

    handleConnectionChange()

    socket?.on("connect", handleConnectionChange)
    socket?.on("disconnect", handleConnectionChange)

    return () => {
      socket?.off("connect", handleConnectionChange)
      socket?.off("disconnect", handleConnectionChange)
    }
  }, [close, show, isOnline, socket?.connected, roomTakenOver, setLocalState])

  return message ? (
    <NetworkMessage
      message={message}
      isOnline={socket?.connected && isOnline}
    />
  ) : null
}

export default NetworkStatusIndicator
